import React from 'react';
import Image from 'next/image';
import Link from 'next/link';
import logo from '../../public/logos/logo-purple.png';

function NavbarQR() {
  return (
    <nav className="w-full flex relative bg-system-100 border-b-[8px] border-turquoise-200 ">
      <div className="m-5">
        <Link href="https://pidemeit.com" className="bg-white md:flex">
          <Image alt="logo" src={logo} height={60} />
        </Link>
      </div>
    </nav>
  );
}

export default NavbarQR;
